import * as React from 'react'

import { Provider, Toaster, system } from '@enechain/ecloud-designsystem'

type Props = {
  children: React.ReactNode
}

export const AppChakraProvider: React.FC<Props> = ({ children }: Props) => {
  return (
    <Provider system={system} forcedTheme="light">
      {children}
      <Toaster />
    </Provider>
  )
}
